export const selectNextRouteLocation = ({ user }) =>
  user?.nextRouteLocation ?? '';
